// src/components/Home.tsx
import React, {FC} from 'react';
import { useState, useRef, useEffect } from "react";
import { DefaultProvider, sha256, toHex, PubKey, bsv, TestWallet, Tx, toByteString } from "scrypt-ts";
import './App.css';

import myGif from '../public/giphy.gif'; // Import the GIF
import mg2 from '../public/aliceClockpng.png'


export let homepvtKey: string = "";
export let homenetwork = bsv.Networks.testnet;
export let compState = true;


const Home00WeBSVmenu: FC = () => {

  const texts = [
    'Menu: ( Home / New PVT Key )', 'Create a new Private Key to Navegate',
    'Menu: ( Home / Access )', 'Use a password or private key to Navegate',
    //'Home/Didactic:', 'Learn some didactic functions',
    //'Satoshi to Peer/Send Satoshi:', 'Transfer satoshis with standart scripts P2PKH and P2PK',
    'Menu: ( Time Stamp / Stamp )', 'Stamp Data on Blockchain',
    'Menu: ( Time Stamp / Check )', 'Check Stamped Data',
    //'Satoshi to Peer/Data Token D:', 'Create-Reshape-Transfer-Melt OP_DROP data Token',
    //'Satoshi to Peer/nSatOrdinals:', 'Create-Reshape-Transfer-Melt 1SatOrdinals or nSatOrdinals',
    //'Satoshi to Peer/UTXO list:', 'Get UTXO list of an Address or Scrip Hash',
    //'Smart Contracts:', 'Coming Soon!!!'
  
  ];

  const [textIndex, setTextIndex] = useState(0);
  const [labelText, setLabelText] = useState(texts[0]);
  const [labelText2, setLabelText2] = useState(texts[1]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      //const newIndex = (textIndex + 1) % texts.length;
      const newIndex = ((textIndex + 2)) % (texts.length);
      setLabelText(texts[newIndex]);
      setLabelText2(texts[newIndex + 1]);
      setTextIndex(newIndex);
    }, 4000); // Change text every 4 seconds

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [textIndex]);


  const containerStyle = {
    //width: '300px', // Set the width of the container
    //height: '200px', // Set the height of the container
    width: '60%',
    height: 'auto',
    //height: '40%',
    overflow: 'hidden', // Hide any overflow outside the container

    display: 'flex',
    alignItems: 'center',
    //paddingLeft: '400px',

    //justify-content: 'center',
  //align-items: 'center',
    justifyContent: 'center',
    //margin: 'right'
  };

  const imageStyle = {
    //width: '80%', // Make the image fit the container width
    maxWidth: '40%',
    height: 'auto', // Automatically adjust the height while maintaining aspect ratio
    paddingLeft: '0px',
  };

  let icon = <div className="alice" > Alice <img src={mg2} alt="" /></div>

  let icon2 = <div className="alice" > <img src={mg2} alt="" /></div>

  let icon3 = <div> <img src={mg2} alt="" /></div>
  let icon4 = <div> <img src={myGif} alt="" style={imageStyle}/></div>
  let icon5 = <div> <img src={myGif} alt="" /></div>
  let icon6 = <div> <img src={myGif} alt="" style={{ maxWidth: '20%', height: 'auto' }} /></div>





  return (

    <div >
      <div className="App-header2">
        <h2 style={{ fontSize: '30px', paddingBottom: '5px', paddingTop: '5px'}}>

          <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
          
          Doc Time Stamper
          {/*
          BlockChain Lightning Web Menu
          Satoshi Vision Web Menu
          Bitcoin Lightning Network
          Bitcoin Lightning Web Menu
          */}
          
        </h2>
      </div>


      <div className="body2">

        {//<h1>Embedded External Website</h1>
               }

        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>
                
                <label style={{ fontSize: '20px', paddingBottom: '2px' }}
                  >Enjoy Navegating  
                </label>     
        </div>



        <div className="body3" style={{ alignItems: 'center', paddingTop: '0px', paddingBottom: '0px' }} > 


        { icon6
              }
          <div style={containerStyle}>


              <img src={myGif} alt="Image" style={{   maxWidth: '40%',   height: 'auto',  paddingLeft: '0px', paddingRight: '30px'}}  />
              <img src={myGif} alt="Image" style={{   maxWidth: '40%',   height: 'auto',  paddingLeft: '0px', paddingRight: '30px'}} />
  
              <img src={mg2} alt="Image" style={{   maxWidth: '40%',   height: 'auto',  paddingLeft: '0px', paddingRight: '0px'}} />
              <img src={myGif} alt="Image" style={{   maxWidth: '40%',   height: 'auto',  paddingLeft: '30px', paddingRight: '0px'}} />
              <img src={myGif} alt="Image" style={{   maxWidth: '40%',   height: 'auto',  paddingLeft: '30px', paddingRight: '0px'}} />
              
          </div>
        </div>




        {/*
        <iframe
          title="External Website"
          //src="https://makc.github.io/misc/relativity-1.html" // Replace with the URL of the website you want to display
          src = 'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcHYxcWlyYTdhaW9ybnZnamhvMHZzbjVzb2QzdG81dXJkeTB4NHJ6ZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3ov9jU4ycPvfrPTsly/giphy.gif'
          width="100%"
          height="200px" // Set the height as needed
          
          allowFullScreen
        ></iframe>

        */}

        <div>

          <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>
                
                <label style={{ fontSize: '14px', paddingBottom: '2px' }}
                  > 
                  {labelText}  
                </label>     

          </div>

          <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '40px' }}>
                
                <label style={{ fontSize: '14px', paddingBottom: '2px' }}
                  > 
                  {labelText2}  
                </label>     
          </div>

          <a href='https://medium.com/@cktcracker/data-time-stamper-b67b3a50f8d6' target="_blank" rel="noopener noreferrer"
          style={{ fontSize: '14px', paddingBottom: '5px', color: 'yellow' }}>
            About Doc Time Stamper
          </a>

        </div>

      </div>

    </div>

  );
};

export default Home00WeBSVmenu;